import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import React, { useState, useEffect, useRef } from 'react';

import './App.css';
import LoginForm from './LoginForm.js';

import Dashboard from './Dashboard.js';
import Reports from './Reports.js';

import TravelReports from './TravelReports.js';
import TravelDeskReports from './TravelDeskReports.js';
import HotelInfoReports from './HotelInfoReports.js';
import Travel_Manager_Audit from './Travel_Approval_Audit.js';
import Hotel_Manager_Audit from './Hotel_Approval_Audit.js';


import ManagerTravelReports from './Manager_Travel_Reports.js';
import TravelManagerApproval from './Travel_Manager_Approval.js';
import HotelManagerApproval from './Hotel_Manager_Approval.js';

import ManagerHotelReports from './Manager_Hotel_Reports.js';
import HotelReports from './HotelReports.js';

import AuditReports from './AuditReports.js';
import EditLocalConveyance from './Edit_LocalConveyance.js'
import ManageReports from './Manage_Reports.js';
import FinanceAdvanceReports from './FinanceAdvanceReports.js';
import FinanceSettlementReports from './FinanceSettlementReports.js';
import ManageSettlementReports from './Manage_Settlement_Reports.js';
import SettlementReports from './SettlementReports.js';
import Dashboard1 from './Dashboard1.js';
import Home from './Home.js';
import Manage_User from './Manage_User.js';
import Add_User from './AddUser.js';
import Add_City from './AddCity.js';
import Add_Advance from './AddAdvanceForm.js';
import Add_Settlement from './AddSettlement.js';
import Add_Settlement_Group from './Add_Settlement_Group.js';
import Add_State from './AddState.js';

import MyDataTable from './MyDataTable.js';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import EditUser from './EditUser';


import EditDashboard from './EditDashboard';
import EditAdvance from './EditAdvanceForm';
import EditManageAdvance from './EditManageAdvanceForm';
import EditSettlementForm from './EditSettlementForm';
import EditSettlementFormGroup from './EditSettlementFormGroup';
import EditTravelDesk from './EditTravelDesk';
import EditFinanceSettlementForm from './EditFinanceSettlementForm';

import EditFinanceSettlementFormGroup from './EditFinanceSettlementFormGroup';
import EditManagerSettlementForm from './EditManageSettlementForm.js';

import EditManagerSettlementFormGroup from './EditManageSettlementGroupForm.js';
import EditAuditFormGroup from './EditAuditFormGroup.js';
import EditFinanceForm from './EditFinanceForm.js';
import EditAuditForm from './EditAuditForm.js';


import ManageSettlement from './ManageSettlement';
import ManageAdvanceAccounts from './ManageAdvanceAccounts';
import ManageEmployee from './ManageEmployee';
import ManageStates from './ManageStates';
import ManageCities from './ManageCities';
import ChangePassword from './ChangePassword';
import ChangePassword1 from './ChangePassword1';
import Purpose from './Purpose';
import ManageTravelDesk from './ManageTravelDesk';
import ManageTravelRequest from './ManageTravelRequest';

import ReportingManageTravelRequest from './Reporting_Manager_Travel_Approval';
import ReportingManageHotelRequest from './Reporting_Manager_Hotel_Approval';
import ManageHotelRequest from './ManageHotelRequest';
import ManageHotelInfo from './ManageHotelInfo';
import ManageAdvanceForm from './ManageAdvanceForm';
import FinanceForm from './FinanceForm';
import FinanceSettlementForm from './FinanceSettlementForm';
import AuditForm from './AuditForm';
import OwnAdvanceForm from './OwnAdvanceForm';
import OwnSettlementForm from './SettlementForm.js';
import ProtectedRoute from './ProtectedRoute';
import EditCity from "./EditCity.js";
import ManageDIEM from "./ManageDIEM.js";
import AddDIEM from "./AddDIEM.js";
import AddPurpose from './AddPurpose';
import EditPurpose from './EditPurpose';
import EditDIEM from "./EditDIEM.js";
import EditState from "./EditState.js";
import EditEmployee from "./EditEmployee.js";
import ResetPassword from "./ResetPassword.js";
import Travel_Desk from "./Travel_Desk.js";
import Travel_Request from "./Travel_Request.js";
import Expence_Request from "./Expence_Request.js";
import Hotel_Request from "./Hotel_Request.js";
import Hotel_Info from "./Hotel_Info.js";
import GetTravelDesk from "./GetTravelDesk.js";
import GetTravelRequest from "./GetTravelRequest.js";
import GetHotelRequest from "./GetHotelRequest.js";
import GetHotelInfo from "./GetHotelInfo.js";

import Edit_LocalConveyance_Rm from './Edit_LocalConveyance_Rm.js';
import Edit_Audit_LocalConveyance from './Edit_Audit_LocalConveyance.js';
import Edit_Accounts_LocalConveyance from './Edit_Accounts_LocalConveyance.js';


import Edit_Manager_Travel_Form from './EditManageTravelForm.js';
import Edit_Manager_Hotel_Form from './EditManageHotelForm.js';

import Edit_Travel_Manager_Form from './EditTravelManager.js';
import Edit_Hotel_Manager_Form from './EditHotelManagerForm.js';
import Travel_Manager from './Travel_Manager.js';
import Hotel_Manager from './Hotel_Manager.js';
import ManageMonthlyExpences from './ManageMonthlyExpences.js';
import Edit_Expence_Request from './edit_expence_request.js';
import ReportingManagerExpence from './ReportingManagerExpence.js';
import AuditExpenceApproval from './AuditExpenceApproval.js';
import AuditExpenceReports from './AuditExpenceReports.js';
import FinanceExpenceReports from './FinanceExpenceReports.js';
import EditReportingManagerExpence from './Edit_Manager_Expence.js';
import EditAuditManagerExpence from './Edit_Audit_Manager_Expence.js';
import EditFinanceManagerExpence from './Edit_Finance_Manager_Expence.js';
import ViewAdvanceTravel from './ViewAdvanceForTravel.js';

import FinanceExpenceApproval from './Finance_Expence_Approval.js';
import EditTravelAdvance from './EditTravelAdvance.js';
import Logged_InUsers from './Logged_InUsers.js';
import NotFoundPage from  './NotFoundPage.js';
import SettlementAuditReports from  './SettlementAuditReports.js';
import SettlementExpenseReports from  './SettlementExpenseReports.js';
import SettlementFinanceReports from  './SettlementFinanceReports.js';
import ManageConveyance from './ManageConveyance.js';
import ManageZMConveyance from './ManageZMConveyance.js';
import ManageCMZMConveyance from './ManageCMZMConveyance.js';
import ManageCheckCMZMConveyance from './ManageCheckCMZMConveyance1.js';
import ManageAuditConveyance from './ManageAuditConveyance.js';
import ManageFinanceConveyance from './ManageFinanceConveyance.js';
import ManageCheckConveyance from './ManageCheckConveyance.js';
import ReportingManagerConveyance from './ReportingManagerConveyance.js';
import AuditConveyance from './AuditConveyance.js';
import FinanceConveyance from './FinanceConveyance.js';
import FinanceConveyanceReports from './FinanceConveyanceReports.js';



import AddLocalConveyance from './Add_LocalConveyance.js';
import AddLocalZMConveyance from './Add_LocalZMConveyance.js';
import AddLocalZMCMConveyance from './Add_ZMCMConveyance.js';
import AddCheckLocalZMCMConveyance from './Add_CheckZMCMConveyance.js';

import AddCheckLocalConveyance from './Add_CheckLocalConveyance.js';



import Manage_Fueltype from './Manage_Fueltype.js';
import Add_Fueltype from './Add_Fueltype.js';
import Edit_Fueltype from './Edit_Fueltype.js';

import Manage_Vehicle_make from './Manage_Vehicle_make.js';
import Add_Vehiclemake from './Add_Vehiclemake.js';
import Edit_Vehiclemake from './Edit_Vehiclemake.js';

import Manage_Vehiclemodal from './Manage_Vehiclemodal.js';
import Add_Vehiclemodal from './Add_Vehiclemodal.js';
import Edit_Vehiclemodal from './Edit_Vehiclemodal.js';

import Manage_Vehicletypes  from './Manage_Vehicletypes.js';
import Add_Vehicletypes from './Add_Vehicletypes.js';
import Edit_Vehicletypes from './Edit_Vehicletypes.js';

import Manage_Vehiclenumber from './Manage_Vehiclenumber.js';
import Add_Vehiclenumber from './Add_Vehiclenumber.js';
import Edit_Vehiclenumber from './Edit_Vehiclenumber.js';

import Manage_Vehicle_Drivers from './Manage_Vehicle_Drivers.js';
import Add_Vehicle_Drivers from './Add_Vehicle_Drivers.js';
import Edit_Vehicle_Drivers from './Edit_Vehicle_Drivers.js';

import FuelForm from './FuelForm.js';
import FuelFormList from './FuelFormList.js';
import Add_Fuel_Form from './Add_Fuel_Form.js';
import Edit_Fuel_form from './Edit_Fuel_form.js';

import Manage_Fuel_Forms from './Manage_Fuel_Forms.js';
import Reporting_Manage_Fuel_Forms from './Reporting_Manage_Fuel_Forms.js';
import Reporting_Manager_Logistic_Forms from './Reporting_Manager_Logistic_Form.js';

import Edit_rm_Fuel_form from './Edit_rm_fuel_form.js';
import Audit_Fuel_forms from './Audit_Fuel_forms.js';
import Edit_audit_Fuel_form from './Edit_audit_fuel_form.js';
import Finance_Fuel_forms from './Finance_Fuel_forms.js';
import Edit_Finance_Fuel_form from './Edit_finance_fuel_form.js';
import Finance_Fuel_Reports from './Finance_Fuel_Reports.js';
import Add_Logistic_Form from './Add_Logistic_Form.js';
import Manage_Logistic_Form from './Manage_Logistic_Form.js';

import Edit_Logistic_form from './editt_Logistic_form.js';

import Edit_rm_Logistic_form from './Edit_rm_logistic_form.js';
import Audit_Logistic_forms from './Audit_Logistic_Form.js';
import Edit_am_Logistic_Form from './Edit_am_logistic_form.js';
import Finance_Logistic_forms from './Finance_Logistic_Form.js';
import Edit_fm_Logistic_Form from './Edit_fm_logistic_form1.js';
import Finance_Logistic_Reports from './Finance_Logistic_reports.js';

import Manage_Repair_Forms from './Manage_Repair_Forms.js';
import Add_Repair_Form from './Add_Repair_Form.js';
import Edit_Repair_Form from './edit_repair_form.js';
import Reporting_Manager_Repair_Forms from './Reporting_Manager_Repair_Forms.js';
import Edit_rm_repair_form from './Edit_rm_repair_form.js';
import Audit_Repair_forms from './Audit_Repair_Form.js';
import Edit_am_repair_form from './Edit_am_repair_form.js';
import Manage_Store_Forms from './Manage_Store_Forms.js';
import Add_Store_Form from './Add_Store_Form.js';
import Route_Mapping from './Route_Mapping.js';
import Add_Route_Map from './Add_Routing_Map.js';
import Vehicle_Tracking from './Vehicle_Tracking.js';
import Add_Vehicle_Tracking from './Add_Vehicle_Tracking.js';
import Edit_Vehicle_Tracking from './EditVehicleTracking.js';
import Edit_Routing_Map from './Edit_Routing_Map.js';
import ChangePassword2 from './ChangePassword2';
import MaintenancePage from './MaintenancePage';
import It_Check_List from './It_Check_List';



import Add_Employee from './Add_Employee';

import Login1 from './LoginForm1';
import Login2 from './LoginForm2';

import Exstation from './Exstation';
import Edit_exstation_form from './Edit_exstation_form';
import Edit_Manager_exstation_form from './Edit_Manager_exstation_form1.js';
import Edit_Audit_exstation_form from './Edit_Audit_exstation_form.js';
import Edit_Finance_exstation_form from './Edit_Finance_exstation_form.js';
import Manage_Conveyance_Master from './ManageZMConveyance.js';
import Edit_CMZM_Conveyance from './Edit_CMZM_Conveyance.js';
import Edit_CHECKCMZM_Conveyance from './Edit_CheckZMCMConveyance.js';
import Edit_AuditCHECKCMZM_Conveyance from './Edit_AuditCheckCMZM_Conveyance.js';
import Edit_AccountCHECKCMZM_Conveyance from './Edit_AccountCHECKCMZM_Conveyance.js';
import Edit_AUDITCMZM_Conveyance from './Edit_AUDITCMZM_Conveyance.js';
import Edit_FINANCECMZM_Conveyance1 from './Edit_FINANCECMZM_Conveyance1.js';
import Edit_ZM_Conveyance from './Edit_ZM_Conveyance';

// import IpCheck from './ip_check.js';

const App = () => {
	// Depend on location to handle refresh flag correctly
	return (

		<Router>
			<Routes>
		<Route path="/" element={<LoginForm />} />
		{/* <Route path="/" element={<MaintenancePage />} /> */}
		<Route path="*" element={<NotFoundPage />} />
				<Route path="/dashboard" element={<Dashboard />} />
				<Route path="/logged_in_users" element={<Logged_InUsers />} />
				<Route path="/reports" element={<Reports />} />
				<Route path="/travel_reports" element={<TravelReports />} />
				<Route path="/travel_desk_reports" element={<TravelDeskReports />} />
				<Route path="/hotel_info_reports" element={<HotelInfoReports />} />
				<Route path="/manager_travel_reports" element={<ManagerTravelReports />} />
				<Route path="/travel_manager_approval" element={<TravelManagerApproval />} />
				<Route path="/hotel_manager_approval" element={<HotelManagerApproval />} />
				<Route path="/manager_hotel_reports" element={<ManagerHotelReports />} />
				{/* <Route path="/ip_check" element={<IpCheck />} /> */}
				<Route path="/hotel_reports" element={<HotelReports />} />
				<Route path="/audit_reports" element={<AuditReports />} />
				<Route path="/manage_reports" element={<ManageReports />} />
				<Route path="/finance_advance_reports" element={<FinanceAdvanceReports />} />
				<Route path="/finance_settlement_reports" element={<FinanceSettlementReports />} />
				<Route path="/manage_settlement_reports" element={<ManageSettlementReports />} />
				<Route path="/settlement_reports" element={<SettlementReports />} />
				<Route path="/settlement_expense_reports" element={<SettlementExpenseReports />} />
				<Route path="/settlement_audit_reports" element={<SettlementAuditReports />} />
				<Route path="/settlement_finance_reports" element={<SettlementFinanceReports />} />
				<Route path="/dashboard1" element={<Dashboard1 />} />
				<Route path="/header" element={<Header />} />
				<Route path="/home" element={<Home />} />
				
				<Route path="/manage_employee" element={<ManageEmployee />} />
				<Route path="/manage_cities" element={<ManageCities />} />
				<Route path="/manage_states" element={<ManageStates />} />
				<Route path="/add_states" element={<Add_State />} />
				<Route path="/add_city" element={<Add_City />} />
				<Route path='/add_diem' element={<AddDIEM />} />
				<Route path="/manage_advance" element={<ManageAdvanceForm />} />
				<Route path="/own_advance" element={<OwnAdvanceForm />} />
				<Route path="/own_settlement" element={<OwnSettlementForm />} />

				<Route path="/manage_advance_accounts" element={<ManageAdvanceAccounts />} />
				<Route path="/manage_settlement" element={<ManageSettlement />} />
				<Route path="/finance_form" element={<FinanceForm />} />
				<Route path="/finance_settlement_form" element={<FinanceSettlementForm />} />
				<Route path="/audit_form" element={<AuditForm />} />

				<Route path="/edit_dashboard/:id" element={<EditDashboard />} />
				<Route path="/edit_advance_form/:id" element={<EditAdvance />} />
				
				<Route path="/edit_manage_advance_form/:id" element={<EditManageAdvance />} />
				<Route path="/edit_travel_desk_form/:id" element={<EditTravelDesk />} />
				<Route path="/edit_settlement_form/:id" element={<EditSettlementForm />} />
				
				<Route path="/edit_settlement_form_group/:id" element={<EditSettlementFormGroup />} />
				<Route path="/edit_manager_settlement_form/:id" element={<EditManagerSettlementForm />} />
				<Route path="/edit_manager_settlement_form_group/:id" element={<EditManagerSettlementFormGroup />} />
				<Route path="/edit_audit_form_group/:id" element={<EditAuditFormGroup />} />
				<Route path="/edit_finance_settlement_form_group/:id" element={<EditFinanceSettlementFormGroup />} />
				<Route path="/edit_finance_form/:id" element={<EditFinanceForm />} />
				<Route path="/edit_audit_form/:id" element={<EditAuditForm />} />
				<Route path="/edit_finance_settlement_form/:id" element={<EditFinanceSettlementForm />} />
				<Route path='/edit_city/:id' element={<EditCity />} />
				<Route path='/edit_travel_advance/:id' element={<EditTravelAdvance />} />
				<Route path='/edit_employee/:id' element={<EditEmployee />} />
				<Route path='/get_travel_desk_form/:id' element={<GetTravelDesk />} />
				<Route path='/get_travel_request_form/:id' element={<GetTravelRequest />} />
				<Route path='/get_hotel_request_form/:id' element={<GetHotelRequest />} />
				<Route path='/get_hotel_info_form/:id' element={<GetHotelInfo />} />
				<Route path='/reset_password/:id' element={<ResetPassword />} />
				<Route path='/edit_state/:id' element={<EditState />} />


				<Route path="/manage_user" element={<ProtectedRoute element={<Manage_User />} requiredType="Y" />} />
				<Route path="/edit_user/:id" element={<ProtectedRoute element={<EditUser />} requiredType="Y" />} />

				<Route path="/mydatatable" element={<MyDataTable />} />
				<Route path="/add_user" element={<Add_User />} />

				<Route path="/travel_desk" element={<Travel_Desk />} />
				<Route path="/travel_request" element={<Travel_Request />} />
				<Route path="/expence_request" element={<Expence_Request />} />
				<Route path="/edit_expence_request/:id" element={<Edit_Expence_Request />} />
				<Route path="/hotel_request" element={<Hotel_Request />} />
				<Route path="/manage_travel_desk" element={<ManageTravelDesk />} />
				<Route path="/manage_travel_request" element={<ManageTravelRequest />} />
				<Route path="/reporting_manager_travel_approval" element={<ReportingManageTravelRequest />} />
				<Route path="/reporting_manager_hotel_approval" element={<ReportingManageHotelRequest />} />
				<Route path="/edit_manager_travel_form/:id" element={<Edit_Manager_Travel_Form />} />
				<Route path="/edit_manager_hotel_form/:id" element={<Edit_Manager_Hotel_Form />} />
				<Route path="/edit_travel_manager_form/:id" element={<Edit_Travel_Manager_Form />} />
				<Route path="/edit_hotel_manager_form/:id" element={<Edit_Hotel_Manager_Form />} />
				<Route path="/travel_approval" element={<Travel_Manager />} />
				<Route path="/hotel_approval" element={<Hotel_Manager />} />
				<Route path="/travel_approval_audit" element={<Travel_Manager_Audit />} />
				<Route path="/hotel_approval_audit" element={<Hotel_Manager_Audit />} />
				
				<Route path="/manage_hotel_request" element={<ManageHotelRequest />} />
				<Route path="/manage_hotel_info" element={<ManageHotelInfo />} />
				<Route path="/hotel_info" element={<Hotel_Info />} />

				<Route path="/purposes" element={<Purpose />} />
				<Route path="/add_advance" element={<Add_Advance />} />
				<Route path="/add_purpose" element={<AddPurpose />} />
				<Route path="/own_advance/all" element={<OwnAdvanceForm />} />
				<Route path="/view_advance_travel" element={<ViewAdvanceTravel />} />
				<Route path="/own_advance/pending" element={<OwnAdvanceForm />} />
				<Route path="/own_advance/approved" element={<OwnAdvanceForm />} />
				<Route path="/own_advance/rejected" element={<OwnAdvanceForm />} />
				<Route path="/manage_travel_request/all" element={<ManageTravelRequest />} />
				<Route path="/manage_travel_request/pending" element={<ManageTravelRequest />} />
				<Route path="/manage_travel_request/approved" element={<ManageTravelRequest />} />
				<Route path="/manage_travel_request/rejected" element={<ManageTravelRequest />} />
				<Route path="/manage_hotel_request/all" element={<ManageHotelRequest />} />
				<Route path="/manage_hotel_request/pending" element={<ManageHotelRequest />} />
				<Route path="/manage_hotel_request/approved" element={<ManageHotelRequest />} />
				<Route path="/manage_hotel_request/rejected" element={<ManageHotelRequest />} />
				<Route path="/own_settlement/all" element={<OwnSettlementForm />} />
				<Route path="/own_settlement/pending" element={<OwnSettlementForm />} />
				<Route path="/own_settlement/approved" element={<OwnSettlementForm />} />
				<Route path="/own_settlement/rejected" element={<OwnSettlementForm />} />
				<Route path="/change_password" element={<ChangePassword />} />
				<Route path="/change_password1" element={<ChangePassword1 />} />
				<Route path="/change_password2/:emp_code" element={<ChangePassword2 />} />
				<Route path="/edit_purpose/:id" element={<EditPurpose />} />
				<Route path="/add_settlement" element={<Add_Settlement />} />
				<Route path="/add_settlement_group" element={<Add_Settlement_Group />} />
				<Route
					path='/manage_diem'
					element={<ManageDIEM />}
				/>
				<Route
					path='/edit_diem/:id'
					element={<EditDIEM />}
				/>
				<Route path="/manage_monthly_expences" element={<ManageMonthlyExpences />} />

				<Route path="/reporting_manager_expences" element={<ReportingManagerExpence />} />
				<Route path="/edit_manager_expence_request/:id" element={<EditReportingManagerExpence />} />
				<Route path="/audit_expence_approval" element={<AuditExpenceApproval />} />
				<Route path="/audit_expence_reports" element={<AuditExpenceReports />} />
				<Route path="/finance_expence_reports" element={<FinanceExpenceReports />} />
				<Route path="/manage_conveyance" element={<ManageConveyance />} />
				<Route path="/manage_zmconveyance" element={<ManageZMConveyance />} />
				<Route path="/manage_cmzmconveyance" element={<ManageCMZMConveyance />} />
				<Route path="/manage_checkcmzmconveyance" element={<ManageCheckCMZMConveyance />} />
				
				<Route path="/audit_cmzmconveyance" element={<ManageAuditConveyance />} />
				<Route path="/finance_cmzmconveyance" element={<ManageFinanceConveyance />} />
				<Route path="/edit_cmzm_conveyance/:id" element={<Edit_CMZM_Conveyance />} />
				<Route path="/edit_checkcmzm_conveyance/:id/:month" element={<Edit_CHECKCMZM_Conveyance />} />
				<Route path="/edit_auditcheckcmzm_conveyance/:id/:month" element={<Edit_AuditCHECKCMZM_Conveyance />} />
				<Route path="/edit_accountcheckcmzm_conveyance/:id/:month" element={<Edit_AccountCHECKCMZM_Conveyance />} />
				<Route path="/edit_auditcmzm_conveyance/:id" element={<Edit_AUDITCMZM_Conveyance />} />
				<Route path="/edit_financecmzm_conveyance/:id" element={<Edit_FINANCECMZM_Conveyance1 />} />
				<Route path="/manage_check_conveyance" element={<ManageCheckConveyance />} />
				<Route path="/reporting_manager_conveyance" element={<ReportingManagerConveyance />} />
				<Route path="/audit_conveyance" element={<AuditConveyance />} />
				<Route path="/finance_conveyance" element={<FinanceConveyance />} />
				<Route path="/finance_conveyance_reports" element={<FinanceConveyanceReports />} />
				<Route path="/edit_rm_local_conveyance/:id" element={<Edit_LocalConveyance_Rm />} />
				<Route path="/edit_audit_local_conveyance/:id" element={<Edit_Audit_LocalConveyance />} />
				<Route path="/edit_accounts_local_conveyance/:id" element={<Edit_Accounts_LocalConveyance />} />
								
				<Route path="/edit_audit_expence_request/:id" element={<EditAuditManagerExpence />} />
				<Route path="/finance_expence_approval" element={<FinanceExpenceApproval />} />
				<Route path="/edit_finance_expence_request/:id" element={<EditFinanceManagerExpence />} />
				<Route path="/add_localconveyance" element={<AddLocalConveyance />} />
				<Route path="/add_localzmconveyance" element={<AddLocalZMConveyance />} />
				<Route path="/add_localzmcmconveyance" element={<AddLocalZMCMConveyance />} />
				<Route path="/add_checklocalzmcmconveyance" element={<AddCheckLocalZMCMConveyance />} />
				<Route path="/add_checklocalconveyance" element={<AddCheckLocalConveyance />} />
				<Route path="/edit_local_conveyance/:id" element={<EditLocalConveyance />} />


				<Route path="/manage_fueltype" element={<Manage_Fueltype />} />
				<Route path="/add_fueltype" element={<Add_Fueltype />} />
				<Route path="/edit_fueltype/:id" element={<Edit_Fueltype />} /> 
				
				<Route path="/manage_vehicle_make" element={<Manage_Vehicle_make />} />
				<Route path="/add_vehicle_make" element={<Add_Vehiclemake />} />
				<Route path="/edit_vehicle_make/:id" element={<Edit_Vehiclemake />} />

				<Route path="/manage_vehicle_modal" element={<Manage_Vehiclemodal />} />
				<Route path="/add_vehicle_modal" element={<Add_Vehiclemodal />} />
				<Route path="/edit_vehicle_modal/:id" element={<Edit_Vehiclemodal />} />

				<Route path="/manage_vehicle_types" element={<Manage_Vehicletypes />} />
				<Route path="/add_vehicle_types" element={<Add_Vehicletypes />} />
				<Route path="/edit_vehicle_types/:id" element={<Edit_Vehicletypes />} />	
				
				<Route path="/manage_vehiclenumber" element={<Manage_Vehiclenumber />} />
				<Route path="/add_vehiclenumber" element={<Add_Vehiclenumber />} />
				<Route path="/edit_vehiclenumber/:id" element={<Edit_Vehiclenumber />} />

				<Route path="/manage_vehicle_drivers" element={<Manage_Vehicle_Drivers />} />
				<Route path="/add_vehicle_drivers" element={<Add_Vehicle_Drivers />} />
				<Route path="/edit_vehicle_drivers/:id" element={<Edit_Vehicle_Drivers />} />
				
				<Route path="/fuel_form/:id" element={<FuelForm />} />
				<Route path="/fuel_form_list" element={<FuelFormList />} />
				<Route path="/add_fuel_form" element={<Add_Fuel_Form />} />
				<Route path="/edit_fuel_form/:id" element={<Edit_Fuel_form />} />

				<Route path="/manage_fuel_forms" element={<Manage_Fuel_Forms />} />
				<Route path="/reporting_manage_fuel_forms" element={<Reporting_Manage_Fuel_Forms />} />
				<Route path="/edit_rm_fuel_form/:id" element={<Edit_rm_Fuel_form />} />
				<Route path="/edit_audit_fuel_form/:id" element={<Edit_audit_Fuel_form />} />
				<Route path="/edit_finance_fuel_form/:id" element={<Edit_Finance_Fuel_form />} />
				<Route path="/audit_fuel_forms" element={<Audit_Fuel_forms />} />
				<Route path="/finance_fuel_forms" element={<Finance_Fuel_forms />} />
				<Route path="/finance_fuel_reports" element={<Finance_Fuel_Reports />} />

				<Route path="/add_logistic_form" element={<Add_Logistic_Form />} />
				<Route path="/manage_logistic_forms" element={<Manage_Logistic_Form />} />
				<Route path="/edit_logistic_form/:id" element={<Edit_Logistic_form />} />
				<Route path="/reporting_manager_logistic_forms" element={<Reporting_Manager_Logistic_Forms />} />
				<Route path="/editrm_logistic_form/:id" element={<Edit_rm_Logistic_form />} />
				<Route path="/audit_logistic_forms" element={<Audit_Logistic_forms />} />
				<Route path="/editam_logistic_form/:id" element={<Edit_am_Logistic_Form />} />
				<Route path="/finance_logistic_forms" element={<Finance_Logistic_forms />} />
				<Route path="/editfm_logistic_form/:id" element={<Edit_fm_Logistic_Form />} />
				<Route path="/finance_logistic_reports" element={<Finance_Logistic_Reports />} />
				<Route path="/manage_repair_forms" element={<Manage_Repair_Forms />} />
				<Route path="/add_repair_form" element={<Add_Repair_Form />} />
				<Route path="/edit_repair_form/:id" element={<Edit_Repair_Form />} />
				<Route path="/reporting_manager_repair_forms" element={<Reporting_Manager_Repair_Forms />} />
				<Route path="/edit_rm_repair_form/:id" element={<Edit_rm_repair_form />} />
				<Route path="/audit_repair_forms" element={<Audit_Repair_forms />} />
				<Route path="/edit_am_repair_form/:id" element={<Edit_am_repair_form />} />
				<Route path="/manage_store_forms" element={<Manage_Store_Forms />} />
				<Route path="/add_store_form" element={<Add_Store_Form />} />
				<Route path="/route_mapping" element={<Route_Mapping />} />
				<Route path="/add_route_mapping" element={<Add_Route_Map />} />
				<Route path="/vehicle_tracking" element={<Vehicle_Tracking />} />
				<Route path="/add_vehicle_tracking" element={<Add_Vehicle_Tracking />} />
				<Route path="/edit_vehicle_tracking/:id" element={<Edit_Vehicle_Tracking />} />
				<Route path="/edit_route_mapping/:id" element={<Edit_Routing_Map />} />
				<Route path="/add_employee" element={<Add_Employee/>}/>
				<Route path="/login1" element={<Login1/>}/>
				<Route path="/login2" element={<Login2/>}/>
				<Route path="/exstation" element={<Exstation/>}/>
				<Route path="/edit_exstation_form/:id" element={<Edit_exstation_form/>}/>
				<Route path="/edit_manager_exstation_form/:id" element={<Edit_Manager_exstation_form/>}/>
				<Route path="/edit_audit_exstation_form/:id" element={<Edit_Audit_exstation_form/>}/>
				<Route path="/edit_finance_exstation_form/:id" element={<Edit_Finance_exstation_form/>}/>
				<Route path="/it_check_list" element={<It_Check_List/>}/>
				<Route path="/manage_conveyance_master" element={<Manage_Conveyance_Master/>}/>
				<Route path="/edit_zm_conveyance/:id" element={<Edit_ZM_Conveyance/>}/>

				{/* Add more routes here */}
			</Routes>

		</Router>
	);
};

export default App;


